import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ButtonColorEnum } from '../buttons/enums/button-color.enum';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnChanges {
  @Input() showModal: boolean = false;
  @Input() title: string = '';
  @Input() includeMain: boolean = true;
  @Input() closeIcon: string = '../../../assets/icons/close.svg';
  @Input() width: string = '';
  @Input() maxWidth: string = '';
  @Input() padding: string = '';
  @Input() footerDisplay: string = '';

  @Output() closeModalFunc: EventEmitter<boolean> = new EventEmitter<boolean>();

  public get ButtonColorEnum() {
    return ButtonColorEnum;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['showModal']) {
      const newValue = changes['showModal'].currentValue;

      if (newValue) {
        document.body.classList.add('modal-open');
      } else {
        document.body.classList.remove('modal-open');
      }
    }
  }

  handleCloseModal() {
    document.body.classList.remove('modal-open');
    this.closeModalFunc.emit(false);
  }
}
